import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader, No_data } from "../../utils/utils";
import { get_rejected_list } from "../../redux/slice/pilotOrdersSlice";
import { Popup } from "../../utils/DialogBox";

const RejectPilotOrders = () => {
  const [view, setView] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const { reject_list, reject_loading } = useSelector(
    (state) => state.pilotOrders
  );
  useEffect(() => {
    dispatch(get_rejected_list());
  }, []);
  return (
    <div>
      {reject_list.length == 0 && reject_loading ? (
        <div className="card p20 df alc jcc">
          <Loader />
        </div>
      ) : reject_list.length == 0 ? (
        <No_data />
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: window.matchMedia("(max-width: 500px)").matches
              ? "repeat(1, 1fr)"
              : window.matchMedia("(max-width: 900px)").matches
              ? "repeat(2, 1fr)"
              : "repeat(3, 1fr)",
            gridGap: 20,
          }}
        >
          {reject_list.map((v, i) => (
            <div className={"grid-item card p20"} key={i}>
              <div className="df alc sb pb6">
                <div className="fs16 fw600 orange ">{v.orderid}</div>
                <div
                  className="fs14 fw600 green cursor"
                  onClick={() => {
                    setData(v.products);
                    setView(true);
                  }}
                >
                  View Products
                </div>
              </div>

              <div className="df  gap10 pb6">
                <div className="fs14 fw400 black">Address:</div>
                <div className="fs14 fw400 black">
                  {v?.deliveryaddress[0]?.address +
                    "," +
                    v?.deliveryaddress[0]?.landmark +
                    "," +
                    v?.deliveryaddress[0]?.district +
                    "," +
                    v?.deliveryaddress[0]?.pincode +
                    "," +
                    v?.deliveryaddress[0]?.state}
                </div>
              </div>
              <div className="df alc gap10 pb6">
                <div className="fs14 fw400 black">Datetime:</div>
                <div className="fs14 fw400 black">{v.datetime}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <Popup
        open={view}
        message={<div className="title-text ">Products detail</div>}
        body={
          <>
            <div className="df alc sb pb6">
              <div className="fs14 fw400 black">Product</div>
              <div className="fs14 fw400 black ">Quantity</div>
            </div>
            {data.map((v, i) => (
              <>
                <div
                  style={{ justifyContent: "space-between", display: "flex" }}
                >
                  <div
                    className="fs16 fw400 black pb6"
                    style={{ lineHeight: 1.3 }}
                  >
                    {v.description}
                  </div>
                  <div
                    className="fs16 fw400 black pb6"
                    style={{ lineHeight: 1.3 }}
                  >
                    {v.count}
                  </div>
                </div>
              </>
            ))}
          </>
        }
        setOpen={setView}
      />
    </div>
  );
};

export default RejectPilotOrders;
